import * as signalR from "@microsoft/signalr";
import { ErrorTemplateBuilder } from "../../infrastructure/error-template-builder";
import { IndexDBSyncManager } from "../../infrastructure/indexdb-sync-manager";

export class SignalRAuMigrationService {
  public setAuMigrationConnectionEvents(connection: signalR.HubConnection) {
    connection.on("aumigration", async (message: any) => {
      try {
        const payload =
          typeof message === "string" ? JSON.parse(message) : message;
        console.log("aumigration", payload);
        await IndexDBSyncManager.clearIndexedDBAndReloadData(true);
        window.location.reload();
      } catch (e) {
        console.error(
          ErrorTemplateBuilder.getCatchText(
            "SignalRAuMigrationService.aumigration",
            e,
          ),
        );
      }
    });
  }
}
